import { render, staticRenderFns } from "./TitlesAndSalutations.vue?vue&type=template&id=0fa11ed7"
import script from "./TitlesAndSalutations.vue?vue&type=script&lang=js"
export * from "./TitlesAndSalutations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports